/* eslint-disable import/prefer-default-export */
import { Autocomplete, Box, FormControl, InputLabel, MenuItem, Popper, Select, TextField } from "@mui/material";
import { PopperProps } from "@mui/material/Popper/BasePopper.types";
import { useEffect, useState } from "react";
import { toHiragana } from "../utils/common";

type Props = {
  label: string;
  options: readonly string[] | string[];
  value: string | string[];
  onChange: Function;
  optionLength?: number;
  multiple?: boolean;
  fullWidth?: boolean;
  required?: boolean;
  disabled?: boolean;
  width?: string;
  maxWidth?: string;
  minWidth?: string;
  isContainBlank?: boolean;
};

/**
 * ポッパーコンポーネント
 * @param props Popperのプロップス
 * @returns JSX.Element
 */
function PopperComponent(props: PopperProps) {
  return <Popper {...props} placement="bottom-start" />;
}

/**
 * インクリメンタルサーチではなく、選択ボックス。時間があれば修正
 * @param param0 プロップス
 * @returns JSX.Element
 */
export function IncrementalSearchElement({
  label,
  options,
  value,
  onChange,
  optionLength,
  multiple,
  fullWidth,
  width,
  maxWidth,
  minWidth,
  required,
  disabled,
  isContainBlank,
}: Props) {
  return (
    <Box width={width ?? "50%"} m={0}>
      <Box p={1}>
        <FormControl sx={{ minWidth: 160 }} required={required}>
          <InputLabel
            id="-label"
            sx={{
              top: "-6px",
              "&.MuiInputLabel-shrink": {
                transform: "translate(14px, -4px) scale(0.75)",
              },
              "& .MuiFormLabel-asterisk": {
                color: "var(--red-800)",
              },
            }}
          >
            {label}
          </InputLabel>
          <Select
            labelId="-label"
            label={label}
            id="1"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            sx={{ height: "40px" }}
            disabled={disabled}
          >
            {isContainBlank && (
              // eslint-disable-next-line no-irregular-whitespace, react/self-closing-comp
              <MenuItem key="" value="">
                &emsp;
              </MenuItem>
            )}
            {options.map((s) => (
              <MenuItem key={s} value={s}>
                {s}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
}

type IncrementalProps = {
  label: string;
  options: string[];
  value: string | string[];
  onChange: Function;
  optionLength?: number;
  multiple?: boolean;
  fullWidth?: boolean;
  isBlankNoOptions?: boolean; // 最初に検索画面が空の場合にオプションを隠す
};

/**
 * 本物のインクリメンタルサーチ
 * @param param0 プロップス
 * @returns JSX.Element
 */
export function GenuineIncrementalSearchElement({
  label,
  options,
  value,
  onChange,
  optionLength,
  multiple,
  fullWidth,
  isBlankNoOptions = true,
}: IncrementalProps) {
  const [inputValueBackup, setInputValueBackup] = useState("");
  const [selectValueBackup, setSelectValueBackup] = useState("");
  const [open, setOpen] = useState(false);
  const filterOptions =
    (): ((opts: string[], { inputValue }: { inputValue: string }) => string[]) =>
    (opts: string[], { inputValue }: { inputValue: string }) =>
      opts
        .filter((o) => toHiragana(o).includes(toHiragana(inputValue)))
        .slice(0, optionLength ?? 5);
  useEffect(() => {
    setOpen(
      !(inputValueBackup === "" && selectValueBackup === "") &&
        !(inputValueBackup === selectValueBackup),
    );
  }, [inputValueBackup, selectValueBackup]);
  useEffect(() => {
    if (!multiple) {
      setInputValueBackup((value as string) ?? "");
      setSelectValueBackup((value as string) ?? "");
    }
  }, [value]);

  return (
    <Box m={1} width={fullWidth ? "calc(100% - 16px)" : "calc(50% - 16px)"}>
      {multiple ? (
        <Autocomplete
          // freeSolo
          multiple
          fullWidth
          // eslint-disable-next-line react/no-unstable-nested-components
          PopperComponent={PopperComponent}
          options={options}
          // filterOptions={(opts, {inputValue}) =>
          //   opts.filter(o => toHiragana(o).includes(toHiragana(inputValue))).slice(0, optionLength ?? 5)
          // }
          value={value as string[]}
          onChange={(e, val) => onChange(val)}
          // onInputChange={(e, value) => handleStorehouseChange(value)}
          size="small"
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              inputProps={{ ...params.inputProps, maxLength: 100 }}
            />
          )}
          limitTags={2}
        />
      ) : (
        <Autocomplete
          // freeSolo
          fullWidth
          // eslint-disable-next-line react/no-unstable-nested-components
          open={isBlankNoOptions ? open : undefined}
          onInputChange={(e, val) => {
            if (isBlankNoOptions) setInputValueBackup(val);
          }}
          popupIcon={null}
          PopperComponent={PopperComponent}
          options={options.map((s) => s)}
          filterOptions={filterOptions()}
          value={(value as string) || null}
          onChange={(e, val) => {
            setSelectValueBackup(val ?? "");
            onChange(val);
          }}
          onBlur={() => setOpen(false)}
          sx={{ height: "40px", maxWidth: 223 }}
          size="small"
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              inputProps={{ ...params.inputProps, maxLength: 100 }}
            />
          )}
        />
      )}
    </Box>
  );
}
